import { lazy } from "react";

import Loadable from "../components/Loadable";
import DashboardLayout from "../components/layout/Sidebar/DashboardLayout";

const Radar = Loadable(lazy(() => import("../pages/dashboard/Radar")));
const Layouts = Loadable(lazy(() => import("../pages/settings/Layouts")));
const HouseComparison = Loadable(
  lazy(() => import("../pages/artificialIntelligence/HouseComparison"))
);

const DesignPreview = Loadable(
  lazy(() => import("../pages/artificialIntelligence/DesignPreview"))
);
const Preferences = Loadable(
  lazy(() => import("../pages/settings/Preferences/Preferences"))
);

const MainRoutes = {
  path: "/",
  element: <DashboardLayout />,
  children: [
    {
      path: "/",
      element: <Radar />,
    },
    {
      path: "radar",
      element: <Radar />,
    },
    {
      path: "layouts",
      element: <Layouts />,
    },
    {
      path: "house-comparison",
      element: <HouseComparison />,
    },
    {
      path: "design-preview",
      element: <DesignPreview />,
    },
    {
      path: "preferences",
      element: <Preferences />,
    },
  ],
};

export default MainRoutes;
